import { v4 as uuidv4 } from 'uuid';

const appointmentData = [
    {
        id: uuidv4(),
        day: 'Monday',
        time: '8AM - 8PM',
    },

    {
        id: uuidv4(),
        day: 'Tuesday',
        time: '8AM - 8PM',
    },

    {
        id: uuidv4(),
        day: 'Wednesday',
        time: '8AM - 8PM',
    },

    {
        id: uuidv4(),
        day: 'Thrusday',
        time: '8AM - 8PM',
    },

    {
        id: uuidv4(),
        day: 'Friday',
        time: '8AM - 8PM',
    },
];

export default appointmentData;
